// Regex to only allow numbers and a single decimal point
const numericFilterInputRegex = /^[0-9]*\.?[0-9]*$/g;

export default (inputValue: string) => {
  const match = inputValue.match(numericFilterInputRegex);
  return match === null ? match : match[0];
};
